export default __webpack_public_path__ + "static/media/EAST1020.34I-33754_-18276_0.f813ac15.jpg";